import { useRef, useState } from "react";
import { Button, Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import "./Acer.css";
import palms1 from "../../../../../assets/palms/cocos-palm.webp";
import palms2 from "../../../../../assets/palms/royal-palm.jpg";
import palms3 from "../../../../../assets/palms/mexican-palm.webp";
import palms4 from "../../../../../assets/palms/robellin.webp";
import palms5 from "../../../../../assets/palms/archontophonix-palm.jpg";
import palmsIcon from "../../../../../assets/palms/palm-animated.jpg";
import Acer from "../../../../../assets/palms/Acer.webp";
import Acer1 from "../../../../../assets/acer/acer1.jpeg";
import Acer2 from "../../../../../assets/acer/acer2.jpeg";
import Acer3 from "../../../../../assets/acer/acer3.jpeg";
import Acer4 from "../../../../../assets/acer/acer4.jpeg";
import Acer5 from "../../../../../assets/acer/acer5.jpeg";
import Acer6 from "../../../../../assets/acer/acer6.jpeg";
import Acer7 from "../../../../../assets/acer/acer7.jpeg";
import Acer8 from "../../../../../assets/acer/acer8.jpeg";
import Acer9 from "../../../../../assets/acer/acer9.jpeg";
import Acer10 from "../../../../../assets/acer/acer10.jpeg";
import Acer11 from "../../../../../assets/acer/acer11.jpeg";
import BackIcon from "../../../../../components/back/back";
import { useNavigate } from "react-router-dom";
export const AcerFamilies = [
    {
        id: 6,
        name: "Acer",
        url: "/acer/acer",
        image: Acer1,
        types: [
            {
                typeName: "Acer dissectum",
                variations: [
                    { src: Acer4, color: "colored", size: "S" },
                    { src: Acer5, color: "colored", size: "M" },
                    { src: Acer6, color: "colored", size: "Big" },
                ],
            },
            {
                typeName: "Acer dissectum pendula",
                variations: [
                    { src: Acer7, color: "red", size: "S" },
                    { src: Acer8, color: "red", size: "Big" },
                    { src: Acer9, color: "green", size: "S" },
                    { src: Acer10, color: "green", size: "M" },
                ],
            },
            {
                typeName: "Acer palmatum",
                variations: [
                    { src: Acer11, color: "yellow", size: "M" },
                    { src: Acer1, color: "green", size: "M" },
                    { src: Acer2, color: "red", size: "S" },
                    { src: Acer3, color: "red", size: "M" },
                ],
            },
        ],
        description: {
            en: "The Acer tree, commonly known as maple, is admired for its striking foliage, especially during autumn when its leaves display vibrant shades of red, orange, and yellow.",
            ar: "تُعرف شجرة القيقب (Acer) بأوراقها اللافتة، خاصةً في فصل الخريف..."
        },
        specifications: {
            en: "- Leaves: Distinct lobed leaves...<br />- Size: Can range from shrubs to large trees.",
            ar: "- الأوراق: أوراق مفصصة...<br />- الحجم: من شجيرات إلى أشجار ضخمة."
        },
        Maintenance: {
            en: "Minimal pruning is required...<br />- Prefers well-drained soil.",
            ar: "لا يتطلب الكثير من التقليم...<br />- تفضل التربة جيدة التصريف."
        }
    }
];



export default function AcerCategorieDesktop() {


    const navigate = useNavigate();
    return (
        <div className="palms-container">
            <BackIcon />
            <div className="title-overlay">
                <h1>Acer Collection</h1>
            </div>

            <div
                className="plants-category-container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8"
                style={{ marginTop: "5rem" }}
            >
                {AcerFamilies.map((acer) => (
                    <div
                        key={acer.id}
                        className="palms-shape-card bg-white p-6 rounded-xl shadow-lg transform transition-all hover:scale-105 cursor-pointer"
                        onClick={() => navigate(acer.url)}
                    >
                        <img
                            src={acer.image}
                            alt={acer.name}
                            className="w-full h-60 object-cover rounded-lg mb-4"
                        />
                        <p className="plant-name">{acer.name}</p>
                    </div>
                ))}
            </div>
        </div>



    );
}